import dynamic from "next/dynamic";
import { SchoolPageData } from "@/components/BnnnerCommon/BannerCommonData";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import Layout from "@/components/Layout/Layout";
import PopupForm from "@/components/PopupForm/PopupForm";
import usePopupVisibility from "@/components/PopupForm/usePopupVisibility";
const SchoolBuildingGlobal = dynamic(
  () => import("@/components/SchoolBuildingGlobal/SchoolBuildingGlobal"),
  { ssr: false }
);
const SchoolEsteemedFaculties = dynamic(
  () => import("@/components/SchoolEsteemedFaculties/SchoolEsteemedFaculties"),
  { ssr: false }
);
const SchoolFaq = dynamic(() => import("@/components/SchoolFaq/SchoolFaq"), {
  ssr: false,
});
const SchoolOurMission = dynamic(
  () => import("@/components/SchoolOurMission/SchoolOurMission"),
  { ssr: false }
);
const SchoolTestimonials = dynamic(
  () => import("@/components/SchoolTestimonials/SchoolTestimonials"),
  { ssr: false }
);
const StickyFooter = dynamic(
  () => import("@/components/StickyFooter/StickyFooter"),
  { ssr: false }
);
const PGProgramme = dynamic(
  () => import("@/components/PGProgramme/PGProgramme"),
  { ssr: false }
);

const BannerCommon = dynamic(
  () => import("@/components/BnnnerCommon/BannerCommon"),
  { ssr: false }
);

const InsightsHighlights = dynamic(
  () => import("@/components/InsightsHighlights/InsightsHighlights"),
  { ssr: false }
);

const SchoolPage = ({ cmsData, commonData }: any) => {
  const { isPopupVisible, hidePopup } = usePopupVisibility();
  const StickyFooterComponent = cmsData?.sticky_footer?.is_sticky_footer_enabled
    ? cmsData?.sticky_footer
    : commonData?.sticky_footer?.is_sticky_footer_enabled
    ? commonData?.sticky_footer
    : null;

  return (
    <Layout
      commonData={commonData}
      SeoData={cmsData?.seo_data}
      schemaFaq={cmsData?.frequently_asked_questions?.questions}
    >
      {isPopupVisible && (
        <PopupForm isVisible={isPopupVisible} onClose={hidePopup} />
      )}

      {cmsData?.banner && (
        <BannerCommon data={SchoolPageData} cmsData={cmsData?.banner} />
      )}
      <div className="breadCrumbStyle">
        <Breadcrumbs classValue="boxStyle" />
      </div>

      {cmsData?.our_mission_detail && (
        <SchoolOurMission data={cmsData?.our_mission_detail} />
      )}
      {cmsData?.school_educator_detail && (
        <SchoolTestimonials data={cmsData?.school_educator_detail} />
      )}
      {cmsData?.building_global_business && (
        <SchoolBuildingGlobal data={cmsData?.building_global_business} />
      )}
      {cmsData?.explore_our_programs && (
        <PGProgramme data={cmsData?.explore_our_programs} />
      )}
      {cmsData?.esteemed_faculties && (
        <SchoolEsteemedFaculties data={cmsData?.esteemed_faculties} />
      )}
      {cmsData?.insights_and_highlights && (
        <InsightsHighlights data={cmsData?.insights_and_highlights} />
      )}
      {cmsData?.frequently_asked_questions && (
        <SchoolFaq data={cmsData?.frequently_asked_questions} />
      )}
      {StickyFooterComponent && <StickyFooter data={StickyFooterComponent} />}
    </Layout>
  );
};

export default SchoolPage;
